import React, {
  PropsWithChildren, useContext, createContext, useMemo,
} from 'react';

interface IExpiredAuthData {
  id: undefined;
  token: undefined;
  tokenExpired: true;
}

interface IValidAuthData {
  id: string;
  token: string;
  tokenExpired: false;
}

export type IAuthData = IExpiredAuthData | IValidAuthData;

interface IAuthContextValue {
  data?: IAuthData;
  isLoading: boolean;
}

const AuthContext = createContext<IAuthContextValue | undefined>(undefined);

export const useAuthContext = () => {
  return useContext(AuthContext);
};

interface IAuthContextProviderProps extends PropsWithChildren {
  value: IAuthData | undefined;
  isLoading: boolean;
}

export const AuthContextProvider = ({
  value, isLoading, children,
}: IAuthContextProviderProps) => {
  const context = useMemo((): IAuthContextValue | undefined => {
    return {
      data: value,
      isLoading,
    };
  }, [value, value?.id, value?.token, value?.tokenExpired, isLoading]);

  return (
    <AuthContext.Provider value={context}>
      {children}
    </AuthContext.Provider>
  );
};
